import {Injectable} from '@angular/core';
import {DataExchangeService} from '../../../../surface3d/src/lib/API/Public/data-exchange.service';
import { Measurement } from 'projects/persistence/src/public-api';
import { PersistenceService } from 'projects/persistence/src/lib/persistence.service';


class BurnedArea {
    public degree: string;
    public percent: string;
}

@Injectable({
    providedIn: 'root'
})
export class TbsaResultsService {

    // get/set
    private _finish: boolean;

    // get
    private _total = '0';

    private _data: BurnedArea[] = [
        {degree: '2a', percent: '0'},
        {degree: '2b', percent: '0'},
        {degree: '3', percent: '0'},
        {degree: '4', percent: '0'}
    ];

    constructor(private dataExchangeService: DataExchangeService, private persistenceService: PersistenceService) {
        this._finish = false;

        this.dataExchangeService.burnSize.subscribe(value => {
            const burnedArea = value;

            if (burnedArea != null) {
                this._data[0].percent = this.burnedAreaToString(burnedArea.burnarea2aT);
                this._data[1].percent = this.burnedAreaToString(burnedArea.burnarea2bT);
                this._data[2].percent = this.burnedAreaToString(burnedArea.burnarea3T);
                this._data[3].percent = this.burnedAreaToString(burnedArea.burnarea4T);
                this._total = this.burnedAreaToString(burnedArea.burnareaT);
                this._parkland = burnedArea.parkland.toFixed(2).toString();
            }

            this.finish = true;
        });
    }

    private _parkland = '0';

    get total(): string {
        return this._total;
    }

    get data(): BurnedArea[] {
        return this._data;
    }

    get finish(): boolean {
        return this._finish;
    }

    set finish(value: boolean) {
        this._finish = value;
    }

    get parkland(): string {
        return this._parkland;
    }

// -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * computes burn data and
     */
    public collectBurnData() {
        this.finish = false;
        this.dataExchangeService.calculateBurnSize();
        if (this.dataExchangeService.patient.id) {
            const result = new Measurement();
            result.setPatientId(this.dataExchangeService.patient.id);
            result.setValue(this._total);
            this.persistenceService.create(result);
        }
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    private burnedAreaToString(burnedArea: number): string {
        return burnedArea >= 0.05 || burnedArea === 0 ?
               burnedArea.toFixed(1).toString() : '< 0.05';
    }

}
